import React from "react";
import { COLORS } from "../strings/COLORS";

const Footer = () => {
  return (
    <footer
      className={`w-full bg-primay p-3 text-center text-white mt-5`}
    >
      © 2024 ISTITUTO NAZIONALE I GEOFISICA E VULCANOLOGIA. All rights reserved.
    </footer>
  );
};

export default Footer;
